import {
    GET_WORKKARD_SEARCH_LIST_SUCCESS,
    FETCH_USER_RECENT_SEARCHES_SUCCESS,
    REMOVE_RECENT_SEARCH_ITEM_SUCCESS,
    RESET_SEARCH_SUGGESTIONS_REQUEST,
    CHANGE_ACTIVE_TAB,
    FETCH_SEARCH_RESULT_DATA_SUCCESS,
    UPDATE_SEARCH_RESULT_DATA_SUCCESS,
    HIDE_GLOBAL_SEARCH_LOADER,
    SHOW_GLOBAL_SEARCH_LOADER,
    RESET_GLOBAL_SEARCH,
    GET_TOPBAR_TABS_COUNT_SUCCESS,
    SAVE_SEARCH_STRING_REQUEST,
    RESET_INDIVIDUAL_GLOBAL_SEARCH
} from "../actions/actionConstants";
import {mergeArrayByKey} from "../../../common/util";

const FIELD_SEQUENCE_MAP = {
    'Customer Name': 1,
    'Property Location': 2,
    'Adjuster Name': 3,
    'Policy Type': 4,
    'Policy Number': 5,
    'Loss Type': 6,
    'Loss Date': 7,
    'Reported Date': 8,
    'Claim Type': 9,
    'Carrier Contact Name': 10,
    'Carrier Contact Phone': 11,
    'Carrier Contact Email': 12,
    'Customer Phone': 13,
    'Customer Email': 14,
    'Carrier Claim Number': 15,
    'Claim Source': 16,
    'Litigation Workkard Number': 17,
    'Track': 18,
    'Building Type': 19,
    'Building Description': 20,
};

const normalizeWorkkardInfo = (workkardInfo) => {
    if (!Array.isArray(workkardInfo)) return workkardInfo;
    
    return workkardInfo.map(field => {
        if (!field || typeof field !== 'object') return field;
        
        const fieldGroup = field.FieldGroup || '';
        const sequence = FIELD_SEQUENCE_MAP[fieldGroup] !== undefined 
            ? FIELD_SEQUENCE_MAP[fieldGroup] 
            : (field.Sequence || 999);
        
        return {
            ...field,
            Sequence: sequence
        };
    });
};

const initialState = {
    isLoading:false,
    suggestion:[],
    recentSearches:[],
    searchString:"",
    activeTab:0,
    workkards:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    activities:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    notes:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    files:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    activityowner:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    workkardsponsor:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    activityassinee:{
        Data:[],
        skip:0,
        take:100,
        Total:0,
        status:null
    },
    counts:{Workkard:0,Activity:0,Note:0,File:0,WorkkardSponsor:0,ActivitiesOwner:0,ActivitiesAssignee:0}
};

const mappingModel = (activeTab,data) => {
    switch(activeTab){
        case 0:
        case 4:
            return(
               {
                    workkardId:data.WorkkardId,
                    workkardNumber:data.WorkkardNumber,
                    workkardSummary:data.WorkkardSummary,
                    sponsorImage: data.SponsorImage,
                    sponsorName : data.SponsorName,
                    carrierName: data.CarrierName,
                    customFields: data.CustomFields,
                    sponsorId:data.Sponsor,
                    WorkkardStatusForDisplay:data.WorkkardStatusForDisplay,
                    workkardTitle: data.WorkkardTitle
                }
            )
        case 1:
        case 5:
        case 6:
            return(
                {
                    activityId: data.ActivityId,
                    workkardId:data.WorkkardId,
                    workkardNumber:data.WorkkardNoFull,
                    createdDate: data.CreatedDateString,
                    activityAssignee:data.ActivityAssignee || data.AssigneeOrgName,
                    activityOwnerName:data.ActivityOwnerName,
                    activityOwnerImage:data.ActivityOwnerImage,
                    activityAssigneeImage:data.ActivityAssigneeImage || data.AssigneeOrgImage,
                    closedDate:data.ClosedDate,
                    resolutionForDisplay : data.Resolution,
                    activityName:data.ActivityName,
                    dueOn:data.DueDateString,
                    skillSet:data.Skillset,
                    customFields:data.CustomFields,
                    workkardInfo: normalizeWorkkardInfo(data.WorkkardInfo),
                    activityOwnerId: data.ActivityOwnerId,
                    activityAssigneeId: data.ActivityAssigneeId,
                    assigneeOrgId: data.AssigneeOrgId,
                    isAssigneeSysUser: data.IsAssigneeSysUser,
                    accessToOrgIds: data.AccessToOrgIds,
                    ownerOrgId: data.OwnerOrgId,
                    statusColor: data.StatusColor,
                    workkardNo: data.WorkkardNo,
                    workkardTemplateId: data.WorkkardTemplateId,
                    progress:data.Progress,
                    isAssigneeSysUser:data.IsAssigneeSysUser,
                    isAssigneeDeleted:data.IsAssigneeDeleted,
                    isAssigneeOrganizationDeleted:data.IsAssigneeOrganizationDeleted
                 }
             );
        case 2:
            return ({
                Id:data.Id,
                Name:data.FirstName +" " + data.LastName,
                OrganizationName:data.OrganizationName,
                PrettyCreatedDate:data.CreatedDate,
                CreatedBy:data.CreatedBy,
                Type:data.Type ?(data.Type).charAt(0).toUpperCase() + (data.Type).slice(1).toLowerCase() : "",
                NoteTemplateName:data.NoteTemplate,
                ActivityNoteCustomFieldViews:data.NoteCustomFields,
                FromResolution:data.FromResolution,
                ToResolution:data.ToResolution,
                ProfileImage:data.ProfileImage,
                Description:data.Description,
                NoteType:data.NoteType,
                ActivityNoteFiles:data.ActivityNoteFiles ? data.ActivityNoteFiles.map((item,key)=>{delete item.CanModifyCaption; return item;})
                                                         : data.ActivityNoteFiles,
                WorkkardFiles:data.WorkkardNoteFiles ? data.WorkkardNoteFiles.map((item,key)=>{delete item.CanModifyCaption; return item;})
                                                     : data.WorkkardNoteFiles,
                NoteCategory:data.NoteCategory,
                WorkkardNumber:data.WorkkardNumber,
                ActivityTitle:data.ActivityTitle,
                workkardId:data.WorkkardId,
                activityId:data.ActivityId
            });
        case 3:
            const splitDate=data.UploadedDate ? data.UploadedDate.split(" ") : [];
            return (
                {
                    UploadedDateString:splitDate[0] + " at "+ splitDate[3] +' '+ splitDate[4],
                    Id:data.FkId,
                    ProfileImage:data.ProfileImage,
                    Name:data.UserName,
                    OrganizationName:data.OrganizationName,
                    OrgId:data.OrgId,
                    ActivityName:data.Title,
                    ParentUrl:data.ParentId,
                    UserId:data.UserId,
                    Type:data.FilePrivacyType ? (data.FilePrivacyType).charAt(0) + (data.FilePrivacyType).slice(1).toLowerCase() : "",
                    Ftype:((data.Category == 'WorkkardFile' || data.Category == "WorkkardNoteFile") ? 'WORKKARD':'ACTIVITY'),
                    Files:[{
                        Ftype:((data.Category == 'WorkkardFile' || data.Category == "WorkkardNoteFile") ? 'WORKKARD':'ACTIVITY'),
                        Type:data.FilePrivacyType,
                        FileType:data.FileType,
                        FileGuid:data.FileGuid,
                        NoteId:data.ParentId,
                        FilePreviewUrl:data.FilePreviewPath,
                        NoteCategory:data.Category,
                        CanModifyCaption:false,
                        OpenFileUrl:data.OpenFilePath,
                        FileName:data.FileName,
                        IsMultiDownload:false,
                        FileUrl:data.FilePath,
                        FileSize:data.FileSize,
                        Caption:data.Caption,
                    }]
                }
            );
    }
  };



export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_SEARCH_STRING_REQUEST:
            return Object.assign({}, state, {searchString:action.payload.string});
        case GET_WORKKARD_SEARCH_LIST_SUCCESS:
            return Object.assign({}, state, {suggestion: action.payload});

        case FETCH_USER_RECENT_SEARCHES_SUCCESS:
            return Object.assign({}, state, {recentSearches: action.payload});

        case REMOVE_RECENT_SEARCH_ITEM_SUCCESS:
            const {wkid,isClearAll}=action.payload;
            if(isClearAll){
                return Object.assign({},state,{recentSearches:[]});
            }
            const filterData=state.recentSearches.filter(item=>(item.WorkkardId != wkid))
            return Object.assign({},state,{recentSearches:filterData});

        case RESET_SEARCH_SUGGESTIONS_REQUEST:
            return Object.assign({},state,{suggestion:{},searchString:""});

        case CHANGE_ACTIVE_TAB:
            return Object.assign({},state,{activeTab:action.payload.activeTab,Data:[],Total:0,skip:0,take:100,status:null})

        case FETCH_SEARCH_RESULT_DATA_SUCCESS:
            let {Data,Total,skip,take,status,type}= action.payload;
            const data=Data!=null ?
                    (Data.length > 0 ? Data.map((item,key)=>{
                        return mappingModel(state.activeTab,item);
                    }) : Data)
                    :
                    []
                    ;
            const newTypeData={[type]:{Data:data,Total:Total,skip:skip,take:take,status:status}}
            return Object.assign({},state,newTypeData);

        case UPDATE_SEARCH_RESULT_DATA_SUCCESS:
            const {key}= action.payload;
            const newData=action.payload.Data.map((item,key)=>{
                return mappingModel(state.activeTab,item);
            })
            const mergedArray = mergeArrayByKey(state[action.payload.type].Data,newData,key);
            const newMergedTypeData={[action.payload.type]:{Data:mergedArray,Total:action.payload.Total,skip:action.payload.skip,take:action.payload.take,status:action.payload.status}}
            return Object.assign({},state,newMergedTypeData);
            
        case HIDE_GLOBAL_SEARCH_LOADER:
            return Object.assign({}, state, {isLoading: false})
        case SHOW_GLOBAL_SEARCH_LOADER:
            return Object.assign({}, state, {isLoading: true});
        case RESET_GLOBAL_SEARCH:
            const newState={
                isLoading:false,
                suggestion:[],
                recentSearches:state.recentSearches,
                activeTab:0,
                workkards:initialState.workkards,
                activities:initialState.activities,
                notes:initialState.notes,
                files:initialState.files,
                activityowner:initialState.activityowner,
                workkardsponsor:initialState.workkardsponsor,
                activityassinee:initialState.activityassinee,
                searchString:"",
                counts:initialState.counts,
                status:null
            }
            return Object.assign({},state,newState);
        case RESET_INDIVIDUAL_GLOBAL_SEARCH:
            const {activeTab} = action.payload;
            let newTabState;
            switch(activeTab){
                case 0:
                    newTabState={workkards:initialState.workkards};
                    break;
                case 1:
                    newTabState={activities:initialState.activities};
                    break;
                case 2:
                    newTabState={notes:initialState.notes};
                    break;
                case 3:
                    newTabState={files:initialState.files};
                    break;
                case 4:
                    newTabState={workkardsponsor:initialState.workkardsponsor};
                    break;
                case 5:
                    newTabState={activityowner:initialState.activityowner};
                    break;
                case 6:
                    newTabState={activityassinee:initialState.activityassinee};
                    break;
                default:
                    break;
            };
            return Object.assign({},state,newTabState);
        case GET_TOPBAR_TABS_COUNT_SUCCESS:
            return Object.assign({}, state, { counts: action.payload });
        default:
            return state;
    }
}